export default "__VITE_ASSET__CJQWmhA8__"